import { createContext, useContext, useEffect, useState } from "react";
import { adminMe, clearToken } from "@/lib/api";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=guest, obj=admin
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const me = await adminMe();
      setAdmin(me);
    } catch {
      setAdmin(false);
      clearToken();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const logout = () => {
    clearToken();
    setAdmin(false);
  };

  return (
    <AdminContext.Provider value={{ admin, isAdmin: !!admin, loading, setAdmin, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
